import _ from 'underscore';

let notifierElement = null,
    visibleNotifications = [];

const defaultNotification = {
    dismissible: true
};

const ERROR_DISSAPEAR_IN_SECONDS = 10;
const DEFAULT_DISSAPEAR_IN_SECONDS = 3;

export default (() => {
    function showValidationNotifications(validationErrors) {
        _.each(validationErrors, fieldErrors => {
            _.each(fieldErrors, message => {
                addNotification({
                    message: message,
                    level: 'error'
                });
            });
        });
    }

    function addNotification(params) {
        let notification = {
            ...params,
            defaultNotification,
            autoDismiss: params.level === 'error' ? ERROR_DISSAPEAR_IN_SECONDS : DEFAULT_DISSAPEAR_IN_SECONDS
        };

        let addedNotification = notifierElement.addNotification(notification);

        visibleNotifications.push(addedNotification);

        // Accessibility: allow screen reader to detect and read alert messages
        document.getElementsByClassName('notifications-wrapper')[0].setAttribute('role', 'alert');

        return addedNotification;
    }

    function removeAllNotifications() {
        visibleNotifications.forEach(notification => {
            notifierElement.removeNotification(notification);
        });

        visibleNotifications = [];
    }

    function removeNotification(params) {
        return notifierElement.removeNotification(params);
    }

    function setNotifierElement(elem) {
        if (notifierElement === null) {
            notifierElement = elem;
        }
    }

    return {
        setNotifierElement,
        removeNotification,
        removeAllNotifications,
        addNotification,
        showValidationNotifications
    };
})();



// WEBPACK FOOTER //
// ./services/notifier.js